import React,{useEffect} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Datetime from "react-datetime";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";

import moment from 'moment';

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import image from "assets/img/9440.jpg";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Slide from "@material-ui/core/Slide";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import TextField from '@material-ui/core/TextField';
import { Grid } from "@material-ui/core";

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});


export default function Sample_Tracking(props) {
 const [car_no,setCarNo]=React.useState('')
 const [driver_no,setDriverNo]=React.useState('')
 const [Total_Sample,setTotal_Sampling]=React.useState(0)
 const [Urgent_Sample,setUrgent_Sampling]=React.useState(0)
 const [sender,setSender]=React.useState('')
 const [destination,setDestination]=React.useState('')
 const [branch,setBranch]=React.useState('Select')
 const [arrival_date,setArrival_Date]=React.useState('')
 const [booking_date,setBooking_Date]=React.useState('')
 const [branchDetail,setBranchDetail]=React.useState([])
  const yesterday = moment().subtract(1, 'day');
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [classicModal, setClassicModal] = React.useState(false);
  const [ServerResponse,setServerResponse]=React.useState('')
  const formatAMPM=(date)=>{
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }
  setTimeout(function() {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  const { ...rest } = props;
  const [reports,setReports]=React.useState('')
 
useEffect(()=>{
  if((localStorage.getItem('patient_name').toLowerCase().includes("device solutions") || localStorage.getItem('patient_name').toLowerCase().includes("mpl-mhc") || localStorage.getItem('patient_name').toLowerCase().includes("nishat multan") || localStorage.getItem('patient_name').toLowerCase().includes("biogene") || localStorage.getItem('patient_name').toLowerCase().includes("medikay") || localStorage.getItem('patient_name').toLowerCase().includes("rawlakot") || localStorage.getItem('patient_name').toLowerCase().includes("genomic rwp") || localStorage.getItem('patient_name').toLowerCase().includes("battagram") || localStorage.getItem('patient_name').toLowerCase().includes('karachi')  || localStorage.getItem('patient_name').toLowerCase().includes('dg khan')  || localStorage.getItem('patient_name').toLowerCase().includes('faisalabad') || localStorage.getItem('patient_name').toLowerCase().includes('nowshera') || localStorage.getItem('patient_name').toLowerCase().includes('peshawar') || localStorage.getItem('patient_name').toLowerCase().includes('gujrat') || localStorage.getItem('patient_name').toLowerCase().includes('jhelum') || localStorage.getItem('patient_name').toLowerCase().includes('sky') || localStorage.getItem('patient_name').toLowerCase().includes('islamabad') || localStorage.getItem('patient_name').toLowerCase().includes('mardan')  || localStorage.getItem('patient_name').toLowerCase().includes('multan') || localStorage.getItem('patient_name').toLowerCase().includes('chakwal') || localStorage.getItem('patient_name').toLowerCase().includes('gujranwala') || localStorage.getItem('patient_name').toLowerCase().includes('butkhela') ||  localStorage.getItem('patient_name').toLowerCase().includes('swat') || localStorage.getItem('patient_name').toLowerCase().includes('sambarial') || localStorage.getItem('patient_name').toLowerCase().includes('tamargarah') || localStorage.getItem('patient_name').toLowerCase().includes('swabi') || localStorage.getItem('patient_name').toLowerCase().includes('dir') || localStorage.getItem('patient_name').toLowerCase().includes('sialkot') || localStorage.getItem('patient_name').toLowerCase().includes('shareef skyways') )  && (localStorage.getItem('role')=='Admin' )){
    setReports('true')
  }else{
    window.location.href="https://fslabs.com.pk/"
  }
 
},[])

  return (
   <>
   {reports=='true' ?
      <div>
      <Header
        absolute
        color="transparent"
        brand="Material Kit React"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >
        <div className={classes.container}>
          
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader  className={classes.cardHeader} style={{backgroundColor:'#1a5790'}}>
                    <h4 style={{color:'white'}}>Sample Tracking</h4>
                    
                  </CardHeader>
                  <CardBody>
                      <GridContainer>
                      <GridItem xs={12} xs={12} md={4} lg={4}>
                  <TextField required id="" block
                  fullWidth={true}
                  label="Sender Name"
                  value={sender}
                  onChange={(e)=>{
                    setSender(e.target.value)
                  }} 
                  
                  />
                  </GridItem>
                  <GridItem xs={0} sm={0} md={4} lg={4}>
                      </GridItem>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                  <TextField required id="" block
                  fullWidth={true}
                  label="Car No / Courier Company Name"
                  value={car_no}
                  onChange={(e)=>{
                    setCarNo(e.target.value)
                  }} 
                  
                  />
                  </GridItem>
                  
                  </GridContainer>
                  <br />
                  <br />
                   <GridContainer fullWidth>
                       <GridItem xs={12} sm={12} md={4} lg={4}>
                       <FormControl fullWidth>
 <Datetime 
                      inputProps={{ placeholder: "Arrival Date" }}
                      value={arrival_date}
                
                      required
                      onChange={(e)=>{
                          setArrival_Date(e)
                      }}
                    />
                    </FormControl>
                       </GridItem>
                       
                           <GridItem xs={0} sm={0} md={4} lg={4}>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4} lg={4}>
                      <FormControl fullWidth>
 <Datetime block
                      inputProps={{ placeholder: "Booking Date & Time" }}
                      value={booking_date}
                      required
                      onChange={(e)=>{
                          setBooking_Date(e)
                      }}
                    /></FormControl>
                       </GridItem>
                       </GridContainer>
                       <br />
                  
                  <br />
                       <GridContainer>
                       <GridItem xs={12} sm={12} md={4} lg={4}>
                  <TextField required id="" block
                  fullWidth={true}
                  label="Driver No/ Tracking No of Courier"
                  type="text"
                  value={driver_no}
                  onChange={(e)=>{
                    setDriverNo(e.target.value)
                  }} 
                  
                  />
                  </GridItem>
                
                           <GridItem xs={0} sm={0} md={4} lg={4}>
                      </GridItem>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                  <TextField required id="" block
                  fullWidth={true}
                  label="Total Samples"
                  type="number"
                  value={Total_Sample}
                  onChange={(e)=>{
                    setTotal_Sampling(e.target.value)
                  }} 
                  
                  />
                  </GridItem>
                       </GridContainer>
                       <br />
                  <br />
                       <GridContainer>
                       <GridItem xs={12} sm={12} md={4} lg={4}>
                  <TextField required id="" block
                  fullWidth={true}
                  label="Urgent Number of Samples"
                  type="number"
                  value={Urgent_Sample}
                  onChange={(e)=>{
                    setUrgent_Sampling(e.target.value)
                  }} 
                  
                  />
                  </GridItem>
                 
                           <GridItem xs={0} sm={0} md={4} lg={4}>
                      </GridItem>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                  <TextField required id="" block
                  fullWidth={true}
                  label="Sample Arrival Location Detail"
                  type="text"
                  value={destination}
                  onChange={(e)=>{
                    setDestination(e.target.value)
                  }} 
                  
                  />
                  </GridItem>
                       </GridContainer>

                     <br />

                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <Button color="#1a5790" size="lg" style={{backgroundColor:'#1a5790'}}
                     onClick={async()=>{
                         var driver_num=driver_no+""
                      if(sender.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Kindly Enter Sender Name !!')
                        return
                       }
                       if(driver_num.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Kindly Enter Driver Number !!')
                        return
                       }
                       if(car_no.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Kindly Select Car No !!')
                        return
                       }
                      
                       if(arrival_date==''){
                        setClassicModal(true)
                        setServerResponse('Invalid Arrival Date & Time!')
                        return
                       }
                       if(booking_date==''){
                        setClassicModal(true)
                        setServerResponse('Invalid Booking Date & Time!')
                        return
                       }
                       if(destination.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Invalid Destination!')
                        return
                       }
                       if(Total_Sample<1){
                        setClassicModal(true)
                        setServerResponse('Invalid Samples!')
                        return
                       }
                       console.log(Total_Sample<Urgent_Sample)
                       if(parseInt(Total_Sample)<parseInt(Urgent_Sample)){
                        setClassicModal(true)
                        setServerResponse('Total Samples must be greater than Urgent Samples!')
                        return
                       }
                     
                  var data={
                      arrival_date:arrival_date.toISOString(),
                      booking_date:booking_date.toISOString(),
                      arrival_time:formatAMPM(arrival_date._d),
                      booking_time:formatAMPM(booking_date._d),
                      car_no:car_no,
                      driver_no:driver_num,
                      total_sample:Total_Sample,
                      urgent_sample:Urgent_Sample,
                      branch:localStorage.getItem('patient_name').toLowerCase().split('mpl-')[1],
                      sender:sender,
                      destination:destination

                  }

                       fetch('https://mpl-labs.felpower.com.pk/addTracking',{
                       method: 'POST',
                       headers:{
                           'Content-Type':'application/json'
                       },
                       body: JSON.stringify(data),  
                    
                    }).then((response) => {
                          return response.json();
                       }).then((res)=>{
                        window.Email.send({
                          Host : "mail.fslabs.com.pk",
                          Username : "sampletracking@fslabs.com.pk",
                          Password : "sampletracking@123",
                          To : 'zainulabbassajid@gmail.com',
                          From : "sampletracking@fslabs.com.pk",
                          Subject : "MPL Branch "+localStorage.getItem('patient_name').toLowerCase().split('mpl-')[1],
                          Body: `<!doctype html>
                                      <html lang="en">
                                        <head>
                                          <!-- Required meta tags -->
                                          <meta charset="utf-8">
                                          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
                                      
                                          <!-- Bootstrap CSS -->
                                          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">
                                      
                                          <title>Free Home Sampling</title>
                                        </head>
                                        <body>
                                          <div class="container">
                                        <table class="table table-dark">
                                          <tbody>
                                            <tr>
                                            <td><b>Sender : </b></td>
                                            <td>&nbsp;`+sender+`</td>
                                            </tr>
                                            <tr>
                                              <td><b>Branch: </b></td>
                                              <td>&nbsp;`+branch+`</td>
                                              </tr>
                                            <tr>
                                            <td><b>Car No / Courier Company Name</b></td>
                                            <td>&nbsp;`+car_no+`</td>
                                            </tr>
                                            <tr>
                                            <td><b>Driver No/ Tracking No of Courier</b></td>
                                            <td>&nbsp;`+driver_no+`</td>
                                            </tr>
                                            <tr>
                                              <td><b>Total Samples :</b></td>
                                              <td>&nbsp;`+Total_Sample+`</td>
                                              </tr>
                                            <tr>
                                            <tr>
                                              <td><b>Urgent Number of Samples</b></td>
                                              <td>&nbsp;`+Urgent_Sample+`</td>
                                            </tr>
                                            
                                          </tbody>
                                          </table>
                                          </div>
                                          <!-- Optional JavaScript -->
                                          <!-- jQuery first, then Popper.js, then Bootstrap JS -->
                                          <script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous"></script>
                                          <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>
                                          <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script>
                                        </body>
                                      </html>`
                                    
                      }).then(
                        message => {console.log(message)}
                      );
                        if(res.value=="Successful"){
                          setClassicModal(true)
                          setServerResponse('Sampling Tracking Record Added!!')
                          setTimeout(()=>{
                            window.location.reload()
                          },3000)
                        return
                        }else{
                          setClassicModal(true)
                          setServerResponse('Sorry , Failed to Add!!')
                          return
                      
                         }
                         
                      })
                       
                       
                     }}
                    >
                      Submit
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            
         
          <GridContainer>
              <GridItem xs={12} sm={12} md={6} lg={4}>

            <Dialog
                  classes={{
                    root: classes.center,
                    paper: classes.modal
                  }}
                  open={classicModal}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => setClassicModal(false)}
                  aria-labelledby="classic-modal-slide-title"
                  aria-describedby="classic-modal-slide-description"
                >
                  <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                  >
                   
                    <h4 className={classes.modalTitle}><b>Sample Tracking</b></h4>
                  </DialogTitle>
                  <DialogContent
                    id="classic-modal-slide-description"
                    className={classes.modalBody}
                  >
                    <p>
                      {ServerResponse}
                    </p>
                  </DialogContent>
                  <DialogActions className={classes.modalFooter}>
                   
                    <Button
                      onClick={() => setClassicModal(false)}
                      color="danger"
                      simple
                    >
                      Ok
                    </Button>
                  </DialogActions>
                </Dialog>
              </GridItem>
          </GridContainer>

        </div>
       
      </div>
    </div>:
    <></>
   }</>
  );
}
